import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PageHeader } from "@/components/PageHeader";
import { BulkForm, BulkResultSection, useBulkConversion } from "@/components/links/BulkSections";
import { Notice } from "@/components/links/Notice";

/** Links em massa: cola post ou lista, converte ate 30 links com status por linha. */
export function LinksEmMassaPage(): JSX.Element {
  const { loading, response, error, setError, run } = useBulkConversion();
  return (
    <div className="max-w-6xl space-y-6">
      <PageHeader
        title="Links em massa"
        subtitle="Cole um post inteiro ou uma lista. Até 30 links por lote, com no máximo 6 de lojas Awin e Rakuten."
      />
      <Card variant="raised">
        <CardHeader className="border-b border-border bg-[hsl(var(--surface-raised)/0.45)]">
          <CardTitle>Texto com links</CardTitle>
          <CardDescription>
            Links repetidos e o mesmo produto em endereços diferentes contam uma vez. Encurtadores como amzn.to,
            s.shopee.com.br e meli.la são resolvidos antes de converter.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 pt-5">
          <BulkForm loading={loading} onSubmit={(text, shorten, found) => void run(text, shorten, found)} />
          {error && <Notice tone="danger">{error}</Notice>}
        </CardContent>
      </Card>
      {response && <BulkResultSection response={response} onCopyError={setError} />}
    </div>
  );
}
